export default [
  // {
  //   "active": true,
  //   "title": "Native Prints",
  //   "__v": 1,
  //   "order": 6,
  //   "date": "January 2018",
  //   "kind": "Sculpture, Performance",
  //   "description": "",
  //   "additional_images": [],
  //   "carousel_images": [],
  //   "cover_image": {
  //     "alt": "",
  //     "__v": 0,
  //     "base_image": {
  //       "name": "arch-project",
  //       "mime": "image/jpeg",
  //       "ext": ".jpg",
  //       "url": "/uploads/arch-project.jpg",
  //     },
  //   },
  //   "poster_image": {
  //     "alt": "",
  //     "__v": 0,
  //     "base_image": {
  //       "name": "arch-project.jpg",
  //       "hash": "2975ac24ecd04e92a4c209249d729582",
  //       "ext": ".jpg",
  //       "mime": "image/jpeg",
  //       "url": "/uploads/arch-project.jpg",
  //     },
  //   }
  // },
  {
    "active": true,
    "title": "Arch Project",
    "__v": 1,
    "order": -1,
    "date": "January 2023",
    "kind": "Simulation, Digital Intervention",
    "description": "An in progress project. The Delicate Arch in Utah is an often used symbol of America's National Parks, and of an idolized view of the 'American Frontier'. This symbol as part of the Parks system implies a dominance over nature tracing back to the colonial roots of the American environmentalist movement.<br><br> Yet the geologic reality of the arch is of a natural feature that is changing, in flux, and outside of control. This project investigates the inevitable moment of the Arch's collapse, and wonders to what ends our society will go to maintain control over nature.",
    "team": "Collaboration with Quinn Kernell",
    "additional_images": [],
    "carousel_images": [],
    "cover_image": {
      "alt": "",
      "__v": 0,
      "base_image": {
        "name": "arch-project",
        "mime": "image/jpeg",
        "ext": ".jpg",
        "url": "/uploads/arch-project.jpg",
      },
    },
    "poster_image": {
      "alt": "",
      "__v": 0,
      "base_image": {
        "name": "arch-project.jpg",
        "hash": "2975ac24ecd04e92a4c209249d729582",
        "ext": ".jpg",
        "mime": "image/jpeg",
        "url": "/uploads/arch-project.jpg",
      },
    }
  },
  {
    "active": false,
    "title": "Cursed",
    "__v": 1,
    "order": 14,
    "type": "development",
    "date": "2019-05-01T08:00:00.000Z",
    "description": "Submission to the <a href=\"https://js13kgames.com/\">Js13k Game Jam</a>. A complete game build for the web using only html, css and js, that compiles to less than 13kb. Built in a week. Theme was the word 'back'. \n<br><br>\nPlay as a \"cursed\" cursor, fighting the browser to regain your shapeshifting powers. The game ended up being way too hard so a bit of a learning experience game-design wise. Really great learning experience coding for size over performance. ",
    "github_url": "https://github.com/ldrummond/js13k_cursed",
    "role": "Designer, Developer",
    "tags": "Game Jam, Simulations",
    "website_url": "https://js13kgames.com/games/cursed/index.html",
    "team": "",
    "additional_images": [],
    "carousel_images": [],
    "cover_image": {
      "alt": "Website showing a game where a cursor shoots at rectangles",
      "__v": 0,
      "base_image": {
         
        "name": "c1.mp4",
         
        "hash": "46e4aa6e9478482f98b4e36df4e7caec",
        "ext": ".mp4",
        "mime": "video/mp4",
        "size": "172.09",
        "url": "/uploads/46e4aa6e9478482f98b4e36df4e7caec.mp4",
         
        "related": [
          "5daa32397977e2ab62c02434"
        ],
         
         
        "__v": 0,
         
      },
       
    },
    "kind": "Web game",
    "short_description": "Web Game created for the JS13k Game Jam that compiles to less than 13kb.",
    "cover_video": [],
    "poster_image": {
       
      "alt": "Website showing a game where a cursor shoots at rectangles",
       
       
      "__v": 0,
      "base_image": {
         
        "name": "5e40baf3c78c4928891a507e112124ff.png",
         
        "hash": "2975ac24ecd04e92a4c209249d729582",
        "ext": ".png",
        "mime": "image/png",
        "size": "192.50",
        "url": "/uploads/2975ac24ecd04e92a4c209249d729582.png",
         
        "related": [
          "5dab4717fb442ede413dd67d"
        ],
         
         
        "__v": 0,
         
      },
       
    }
  },
  {
    "active": true,
    "title": "Part To Whole",
    "__v": 1,
    "date": "2019-06-01T08:00:00.000Z",
    "description": "A website exploring the phenomenon of <em>emergence</em>. Emergence describes a complex pattern arising from simple interactions between parts. This phenomenon exists in everything from science and art to philosophy and the natural world.\nThe goal of the project is to highlight the related structure of seemingly disconnected systems and encourage an awareness of alternate modes of organizing and non-heirarchical action.",
    "github_url": "https://github.com/ldrummond/capstone-2019",
    "order": 0,
    "role": "Designer, Developer",
    "tags": "Interactive, Simulations",
    "type": "development",
    "website_url": "https://part-to-whole.netlify.com",
    "carousel_images": [
      {
         
        "alt": "Website menu asking \"Why do bats coordinate their flight?\"",
        "caption": "",
        "__v": 0,
        "title": "Bats Cover",
        "base_image": {
           
          "name": "parttowhole1.jpg",
          "hash": "bb9a2e807ffd40c4988c8e2bb195924d",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "321.35",
          "url": "/uploads/bb9a2e807ffd40c4988c8e2bb195924d.jpg",
           
          "related": [
            "5d9a1e38b84541b7b5db1014"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
        "alt": "Website interactive page explaining \"What causes traffic to form\" ",
        "caption": "",
         
         
        "__v": 0,
        "title": "Traffic Simulation",
        "base_image": {
           
          "name": "parttowhole2.jpg",
           
          "hash": "596eb2bbb6d5414f97b36f7c5fe9d0ca",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "439.21",
          "url": "/uploads/596eb2bbb6d5414f97b36f7c5fe9d0ca.jpg",
           
          "related": [
            "5d9a26e2bbcebfbb91b1db8b"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
        "alt": "Rectangles representing a simulation of cars in traffic ",
        "caption": "",
         
         
        "__v": 0,
        "title": "Traffic Simulation Detail",
        "base_image": {
           
          "name": "parttowhole3.jpg",
           
          "hash": "92eecc4280a74a46aff260925c7bb348",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "515.92",
          "url": "/uploads/92eecc4280a74a46aff260925c7bb348.jpg",
           
          "related": [
            "5d9a26e2bbcebfbb91b1db8c"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
        "alt": "Website page with image of a bat overlapping an orange arrow symbol",
        "title": "Bat Splash Screen",
         
         
        "__v": 0,
        "base_image": {
           
          "name": "parttowhole4.jpg",
           
          "hash": "6182421a9ec94822a33d513f1add9246",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "427.58",
          "url": "/uploads/6182421a9ec94822a33d513f1add9246.jpg",
           
          "related": [
            "5d9f68e82459af12b19ed5b2"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
        "alt": "Website showing an interactive simulation an the question \"How do fish avoid predators?\" ",
        "title": "Fish Interaction ",
         
         
        "__v": 0,
        "base_image": {
           
          "name": "parttowhole5.jpg",
           
          "hash": "55bd4cf039664a5f93a7c98eec5b7d07",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "504.04",
          "url": "/uploads/55bd4cf039664a5f93a7c98eec5b7d07.jpg",
           
          "related": [
            "5d9f68e82459af12b19ed5b3"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
        "alt": "Detail of interactive simulation of mold networks",
        "title": "Mold Simulation Detail",
         
         
        "__v": 0,
        "base_image": {
           
          "name": "parttowhole6.jpg",
           
          "hash": "7eec1b518a6d47cb8e746dcb687428a9",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "471.63",
          "url": "/uploads/7eec1b518a6d47cb8e746dcb687428a9.jpg",
           
          "related": [
            "5d9f68e82459af12b19ed5b4"
          ],
           
           
          "__v": 0,
           
        },
         
      }
    ],
    "additional_images": [],
    "cover_image": {
       
      "alt": "Website showing an image of a bat overlapping an arrow icon",
       
       
      "__v": 0,
      "title": "Fish video",
      "base_image": {
         
        "name": "parttowhole4.jpg",
         
        "hash": "57eddfb001ea4dee9b2c323421a1164e",
        "ext": ".jpg",
        "mime": "image/jpeg",
        "size": "427.58",
        "url": "/uploads/57eddfb001ea4dee9b2c323421a1164e.jpg",
         
        "related": [
          "5d9f67d51f87701243d583ae"
        ],
         
         
        "__v": 0,
         
      },
       
    },
    "extra_test": [],
    "kind": "Interactive website",
    "short_description": "Website exploring the phenomenon of emergence through 5 interactive simulations.",
    "poster_image": null
  },
  {
    "active": false,
     
    "title": "Riders of New York",
     
     
    "__v": 0,
     
    "date": "2019-05-02T08:00:00.000Z",
    "description": "An interactive data visualization exploring public data from \"City Bike\", New York City's public ride-share program. City Bike is the largest and most used bike sharing program in the United States, and this project seeks to highlight the way data and demographics reveal unexpected use patterns.\n<br><br>\nThe project analyzes gender, subscriber and location demographics for the riders. It also maps the change in rider usage over time. Certain trends, like the increase of non-subscriber riders on weekends or the quantity of trips ending at Grand Central Station, become apparent through the relationship between the different types of visualizations. Created primarily as an excercise in development, the design of the site could be revisitedto better guide the viewer through data.",
    "github_url": "",
    "order": 3,
    "role": "Designer, Developer",
    "tags": "Interactive, Data Visualization",
    "team": "Robin Linzmayer, Amelia Santrach",
    "website_url": "https://ldrummond.github.io/riders_of_new_york",
    "type": "development",
    "additional_images": [],
    "carousel_images": [
      {
         
        "alt": "Detail of a map of NY highlighting bikeshare usage",
        "title": "NY Visualization Map Detail",
         
         
        "__v": 0,
        "base_image": {
           
          "name": "ridersofny1.jpg",
           
          "hash": "32090b894ad34720946d02ff7459b356",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "445.90",
          "url": "/uploads/32090b894ad34720946d02ff7459b356.jpg",
           
          "related": [
            "5d9f69ed2459af12b19ed5c3"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
        "alt": "Overview of a visualization tool for New York City bikeshare usage",
        "title": "Visualization Overview",
         
         
        "__v": 0,
        "base_image": {
           
          "name": "ridersofny2.jpg",
           
          "hash": "3ac39d8f679b4d2cb6bbaca5ebaaf588",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "635.64",
          "url": "/uploads/3ac39d8f679b4d2cb6bbaca5ebaaf588.jpg",
           
          "related": [
            "5d9f69ed2459af12b19ed5c4"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
        "alt": "Detail of a visualization highlighting the Empire State Building",
        "title": "Visualization Location Detail",
         
         
        "__v": 0,
        "base_image": {
           
          "name": "ridersofny3.jpg",
           
          "hash": "af3db7e47da34c9fbf4aaad22073a757",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "253.08",
          "url": "/uploads/af3db7e47da34c9fbf4aaad22073a757.jpg",
           
          "related": [
            "5d9f69ed2459af12b19ed5c5"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
        "alt": "Detail of a visualization showing bike usage trends during times of the week",
        "title": "Visualization Rider Usage Detail",
         
         
        "__v": 0,
        "base_image": {
           
          "name": "ridersofny4.jpg",
           
          "hash": "9674f1e4469044868cb19de410b8f300",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "356.14",
          "url": "/uploads/9674f1e4469044868cb19de410b8f300.jpg",
           
          "related": [
            "5d9f69ed2459af12b19ed5c6"
          ],
           
           
          "__v": 0,
           
        },
         
      }
    ],
    "cover_image": null,
    "kind": "Data visualization",
    "short_description": "An interactive data visualization exploring public data from \"City Bike\", New York City's public ride-share program.",
    "poster_image": null
  },
  {
    "active": true,
    "title": "Memory Swap",
    "__v": 0,
    "date": "2019-05-01T08:00:00.000Z",
    "description": "An experimental clothing swap exploring the ways in which we embed our memories in objects. We all have articles of clothing we never wear, but keep only for the memories they signify. The goals of this project were to give these clothes a new life, but also to provide an opportunity for people to share their memories while letting go of the physical artifacts.\n<br><br>\n Participants were encouraged to donate significant clothes and share their memory with that item. The memory was then printed on a label stitched into the item, and it was catalogued and added to a digital archive; future thrifters could find clothes with embedded memories, give them new lives and add their own memories.",
    // "role": "Designer, Developer",
    "tags": "Relational, User-research",
    "team": "Jessica Fan, Carmen von Unrug, Jee Li",
    "type": "design",
    "website_url": "https://memoryswap.netlify.com/",
    "order": 2,
    "additional_images": [],
    "carousel_images": [
      {
         
        "alt": "Ecommerce website layout titled \"Memory Swap\" and showing a variety of clothes",
        "title": "Memory Swap Cover",
         
         
        "__v": 0,
        "base_image": {
           
          "name": "memoryswap1.png",
           
          "hash": "26d18cdeec0f4387afac43fdd8d17260",
          "ext": ".png",
          "mime": "image/png",
          "size": "920.64",
          "url": "/uploads/26d18cdeec0f4387afac43fdd8d17260.png",
           
          "related": [
            "5d9f6b282459af12b19ed5d7"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
        "alt": "Detail of an E-commerce page showing an image of a scarf and a story about the scarf.",
        "title": "Scarf Detail Page",
         
         
        "__v": 0,
        "base_image": {
           
          "name": "memoryswap2.jpg",
           
          "hash": "8716ffd4849843188b19b9c8cd7ded77",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "732.12",
          "url": "/uploads/8716ffd4849843188b19b9c8cd7ded77.jpg",
           
          "related": [
            "5d9f6b282459af12b19ed5d8"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
        "alt": "A pile of tags used for submitting clothes to a memory related clothing donation project",
        "title": "Tags Detail",
         
         
        "__v": 0,
        "base_image": {
           
          "name": "memoryswap3.jpg",
           
          "hash": "6c489d6afef44587a735f7dca0776560",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "469.40",
          "url": "/uploads/6c489d6afef44587a735f7dca0776560.jpg",
           
          "related": [
            "5d9f6b282459af12b19ed5d9"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
        "title": "Tags Detail 2",
        "alt": "A close up of a single clothing submission tag with the item number 7",
         
         
        "__v": 0,
        "base_image": {
           
          "name": "memoryswap4.jpg",
          "sha256": "yV3EYDXY08ccJoSdfSX3CqovUTG_xE-D+-7PGls6QS4",
          "hash": "d609501739be4431a20381fd21e2847b",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "321.81",
          "url": "/uploads/d609501739be4431a20381fd21e2847b.jpg",
           
          "related": [
            "5d9f6b282459af12b19ed5da"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
        "alt": "A close up of the tag highlighting the grommet attachment in the corner and the number 7",
        "title": "Tag Detail 3",
         
         
        "__v": 0,
        "base_image": {
           
          "name": "memoryswap5.jpg",
           
          "hash": "84d9df341b23440bbb47bdaf3885674d",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "381.75",
          "url": "/uploads/84d9df341b23440bbb47bdaf3885674d.jpg",
           
          "related": [
            "5d9f6b282459af12b19ed5db"
          ],
           
           
          "__v": 0,
           
        },
         
      }
    ],
    "cover_image": null,
    "kind": "Participatory Clothing Swap",
    "short_description": "Experimental e-commerce & clothing swap exploring the ways we embed memories in our clothes.",
    "poster_image": null
  },
  {
    "active": false,
     
    "title": "The Art of Travel",
     
     
    "__v": 0,
     
    "date": "2017-01-01T08:00:00.000Z",
    "description": "<em>The Art of Travel,</em> written by Elain de Botton, investigates the act of traveling in all its splendor and in its tribulations. Botton suggests that the value of travel lies in the unappreciated details—the airports, the arguments, the mini-bars and hotel carpets—and that the story of a trip is never a simple narrative. \n<br><br>\nInspired by Botton's work, I created a website that allows a reading of <em>The Art of Travel,</em> utilizing a non-linear narrative structure reflective of both the act of traveling, and of the message in Botton's work. The site allows the viewer to traverse Botton's text through sentences catalogued by reoccuring objects and experiences, hyperlinking text pages together. The hyperlink text within each page is replaced by a set of images, encouraging the viewer to form their own unique narrative as they travel through the site. ",
    "order": 5,
    "role": "Designer, Developer",
    "tags": "Non-linear",
    "website_url": "http://lucasbuilds.site/The-Art-of-Travel/source.html",
    "type": "development",
    "additional_images": [],
    "carousel_images": [
      {
         
        "alt": "Website showing a series of images and the title \"The Art of Travel\"",
        "title": "The Art of Travel Cover",
         
         
        "__v": 0,
        "base_image": {
           
          "name": "artoftravel1.jpg",
           
          "hash": "9cf0d8cecfdf4b64bddc62c931892925",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "138.62",
          "url": "/uploads/9cf0d8cecfdf4b64bddc62c931892925.jpg",
           
          "related": [
            "5d9f6c3a2459af12b19ed5fa"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
        "alt": "Website showing a section of a story about traveling on a featureless motorway",
        "title": "Travel Text Detail",
         
         
        "__v": 0,
        "base_image": {
           
          "name": "artoftravel2.jpg",
           
          "hash": "0f99e8a75f294e81abb3dff473edb827",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "397.47",
          "url": "/uploads/0f99e8a75f294e81abb3dff473edb827.jpg",
           
          "related": [
            "5d9f6c3a2459af12b19ed5fb"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
        "alt": "Website showing a section of narrative where the word service station is replaced by an image of a service station",
        "title": "Travel Image Detail",
         
         
        "__v": 0,
        "base_image": {
           
          "name": "artoftravel3.jpg",
           
          "hash": "1eab175351bb47d29fdaa085f93864cd",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "404.25",
          "url": "/uploads/1eab175351bb47d29fdaa085f93864cd.jpg",
           
          "related": [
            "5d9f6c3a2459af12b19ed5fc"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
        "alt": "Detail of a section of text about planes overlapping an image of a plane",
        "title": "Travel Image Overlap Detail",
         
         
        "__v": 0,
        "base_image": {
           
          "name": "artoftravel4.jpg",
           
          "hash": "e05655f0a7e2414a9282d67afaa3a32a",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "287.09",
          "url": "/uploads/e05655f0a7e2414a9282d67afaa3a32a.jpg",
           
          "related": [
            "5d9f6c3a2459af12b19ed5fd"
          ],
           
           
          "__v": 0,
           
        },
         
      }
    ],
    "cover_image": null,
    "kind": "Digital narrative",
    "short_description": "A website that tells a non-linear narrative through images of recurring experiences.",
    "poster_image": null
  },
  {
    "active": false,
     
    "title": "Protectwise",
     
     
    "__v": 0,
     
    "date": "2018-06-12T08:00:00.000Z",
    "description": "A series of illustrations designed to abstract the process of using the Protectwise network security software. The project included hero graphics and a set of icons. The complex and specific nature of the software and related terms made the design process challenging, but also encouraged creative abstraction. In 2019 Protectwise was purchased by Verizon and their website is no longer accessible. ",
    "order": 6,
    "role": "Designer, Illustrator",
    "tags": "Web Graphics",
    "team": "Legwork Studio",
    "type": "illustration",
    "additional_images": [],
    "carousel_images": [
      {
         
        "alt": "A vector icon representing a computer network ",
        "title": "Protectwise Cover",
         
         
        "__v": 0,
        "base_image": {
           
          "name": "protectwise1.jpg",
          "sha256": "5baV_jHQDfaSEpzC5PZq+039I+BPNI3yx1Ghc4P51FA",
          "hash": "c94df2983c6140f4a54e9d4f957f5073",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "49.74",
          "url": "/uploads/c94df2983c6140f4a54e9d4f957f5073.jpg",
           
          "related": [
            "5d9f6daf2459af12b19ed60b"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
        "alt": "Abstract digital illustration of a figure composed of colored dots and lines",
        "title": "Protectwise Figure",
         
         
        "__v": 0,
        "base_image": {
           
          "name": "protectwise2.jpg",
           
          "hash": "ac50521eb5cf4e528e9d1f9b7129691c",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "233.92",
          "url": "/uploads/ac50521eb5cf4e528e9d1f9b7129691c.jpg",
           
          "related": [
            "5d9f6daf2459af12b19ed60c"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
        "alt": "Abstract digital illustration of menu panels composed of orange and grey geometric symbols",
        "title": "Protectwise Menu Panels",
         
         
        "__v": 0,
        "base_image": {
           
          "name": "protectwise3.jpg",
           
          "hash": "2aba9464a8564c42ac4398b67d7e88ca",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "281.51",
          "url": "/uploads/2aba9464a8564c42ac4398b67d7e88ca.jpg",
           
          "related": [
            "5d9f6daf2459af12b19ed60d"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
        "alt": "6 icons representing different aspects of computer networks",
        "title": "Protectwise Icon Set",
         
         
        "__v": 0,
        "base_image": {
           
          "name": "protectwise4.jpg",
           
          "hash": "9f769bb340594664993afda102674cd4",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "310.80",
          "url": "/uploads/9f769bb340594664993afda102674cd4.jpg",
           
          "related": [
            "5d9f6daf2459af12b19ed60e"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
        "alt": "Website detail highlighting icons representing network security",
        "title": "Protectwise Site Detail",
         
         
        "__v": 0,
        "base_image": {
           
          "name": "protectwise5.jpg",
          "sha256": "CNq_oP3Rt727JauRx8ejdNZ+4cs6X1LL97rqdL1lYDc",
          "hash": "9cf59a943cfa4ccc940d6ec935fed713",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "126.39",
          "url": "/uploads/9cf59a943cfa4ccc940d6ec935fed713.jpg",
           
          "related": [
            "5d9f6daf2459af12b19ed60f"
          ],
           
           
          "__v": 0,
           
        },
         
      }
    ],
    "cover_image": null,
    "kind": "Web graphics",
    "short_description": "Digital illustrations for a Network Security website.",
    "poster_image": null
  },
  {
    "active": true,
    "title": "Digital Dendrology",
    "__v": 0,
    "date": "2016-01-01T08:00:00.000Z",
    "description": "A field guide for Google Earth, inviting users to participate in virtual tree identification. Both serious and absurd, the guide invites users to speculate on the relationship between digital and physical experiences, the authenticity of digital reproductions, and the absurdity of trying to preserve the world through inelastic digital records.",
    // "description": "A surreal field guide for digital plant identification. The internet is a wilderness: it is so full of raw information, data, paths and endpoints, that it is easy to lose your way and very difficult to tell what is important among the mass. A perfect example is Google Earth—within its servers are infinite points of data that are simultaneously empowering and incomprehensible.\n<br><br>\nDigital Dendrology is a Field Guide created to help digital explorers better navigate Google Earth, specifically looking at the digital trees that populate the program.\n<br><br>\nThough algorithmically rendered, these trees are based on satellite photographs and therefore have real-world equivalences. By comparing data to printed and cataloged botany databases, I was able to identify the species and location of many Google Earth trees. I organized these into a hand held field guide, easy to use while traveling the web, that features both sample identifications, GPS coordinates of identified trees and tools for aiding the reader in their own research.",
    "order": 1,
    "role": "Designer",
    "tags": "Generative, Guide",
    "type": "design",
    "additional_images": [],
    "carousel_images": [
      {
        "alt": "A digital rendering of a Gingko tree pulled from Google Earth",
        "base_image": {
           
          "name": "Gingko 2.png",
           
          "hash": "62c1a012179f4fed8aef402ae2e4d0de",
          "ext": ".png",
          "mime": "image/png",
          "size": "231.71",
          "url": "/uploads/62c1a012179f4fed8aef402ae2e4d0de.png",
           
          "related": [
            "5da7b346ec528e6e3faffacb"
          ],
        },
      },
      {
        "__v": 0,
        "base_image": {
           
          "name": "dendrology1.jpg",
           
          "hash": "d3006e1093494f35867afdcd8df5ad82",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "224.81",
          "url": "/uploads/d3006e1093494f35867afdcd8df5ad82.jpg",
           
          "related": [
            "5d9f6e4e2459af12b19ed623"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
         
         
        "__v": 0,
        "base_image": {
           
          "name": "dendrology2.jpg",
           
          "hash": "e596c982ade141128fca7a3b96aee8e5",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "378.51",
          "url": "/uploads/e596c982ade141128fca7a3b96aee8e5.jpg",
           
          "related": [
            "5d9f6e4e2459af12b19ed624"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
         
         
        "__v": 0,
        "base_image": {
           
          "name": "dendrology3.jpg",
           
          "hash": "21c8cf9ebb1f40d9855d248b02eabda6",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "246.66",
          "url": "/uploads/21c8cf9ebb1f40d9855d248b02eabda6.jpg",
           
          "related": [
            "5d9f6e4e2459af12b19ed625"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
         
         
        "__v": 0,
        "base_image": {
           
          "name": "dendrology4.jpg",
           
          "hash": "0155353a571546788808eefbb563163a",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "151.44",
          "url": "/uploads/0155353a571546788808eefbb563163a.jpg",
           
          "related": [
            "5d9f6e4e2459af12b19ed626"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
         
         
        "__v": 0,
        "base_image": {
           
          "name": "dendrology5.jpg",
           
          "hash": "82e075f88e0f4dbab1a75e24ef1a7736",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "137.51",
          "url": "/uploads/82e075f88e0f4dbab1a75e24ef1a7736.jpg",
           
          "related": [
            "5d9f6e4e2459af12b19ed627"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
         
         
        "__v": 0,
        "base_image": {
           
          "name": "dendrology6.jpg",
           
          "hash": "27b94baafaf04c2e96a2670e40844f7f",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "64.52",
          "url": "/uploads/27b94baafaf04c2e96a2670e40844f7f.jpg",
           
          "related": [
            "5d9f6e4e2459af12b19ed628"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
         
         
        "__v": 0,
        "base_image": {
           
          "name": "dendrology7.jpg",
           
          "hash": "8bf74ada638944568e06f3e8a40163da",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "96.03",
          "url": "/uploads/8bf74ada638944568e06f3e8a40163da.jpg",
           
          "related": [
            "5d9f6e4e2459af12b19ed629"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
         
         
        "__v": 0,
        "base_image": {
           
          "name": "dendrology8.jpg",
           
          "hash": "3eb57a0b69af4108bc27f7ab8ba1f8a9",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "139.24",
          "url": "/uploads/3eb57a0b69af4108bc27f7ab8ba1f8a9.jpg",
           
          "related": [
            "5d9f6e4e2459af12b19ed62a"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
         
         
        "__v": 0,
        "base_image": {
           
          "name": "dendrology9.jpg",
           
          "hash": "68eca81af6c24dd9ba0a601c5c60f709",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "113.91",
          "url": "/uploads/68eca81af6c24dd9ba0a601c5c60f709.jpg",
           
          "related": [
            "5d9f6e4e2459af12b19ed62b"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
         
         
        "__v": 0,
        "base_image": {
           
          "name": "dendrology10.jpg",
          "sha256": "FS4Me3f-F8rk89cYkNMUvNthF0Xrn9GVP91_d2ad+9Q",
          "hash": "905bbe885ca94505a8d91fc75e58005c",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "349.30",
          "url": "/uploads/905bbe885ca94505a8d91fc75e58005c.jpg",
           
          "related": [
            "5d9f6e4e2459af12b19ed62c"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
         
         
        "__v": 0,
        "base_image": {
           
          "name": "dendrology11.jpg",
           
          "hash": "f381b3cdd4704312a0d2fdb12bbba661",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "277.82",
          "url": "/uploads/f381b3cdd4704312a0d2fdb12bbba661.jpg",
           
          "related": [
            "5d9f6e4e2459af12b19ed62d"
          ],
           
           
          "__v": 0,
           
        },
         
      }
    ],
    "cover_image": {
       
      "alt": "A digital rendering of a Gingko tree pulled from Google Earth",
      "title": "Ginko",
       
       
      "__v": 0,
      "base_image": {
         
        "name": "Gingko 2.png",
         
        "hash": "d2dd03f1dc8747f8b0aa004bb459638e",
        "ext": ".png",
        "mime": "image/png",
        "size": "231.71",
        "url": "/uploads/d2dd03f1dc8747f8b0aa004bb459638e.png",
         
        "related": [
          "5da658293b4c2d68bce56641"
        ],
         
         
        "__v": 0,
         
      },
       
    },
    "kind": "Field guide",
    "short_description": "A Field Guide for identifying trees in Google Earth.",
    "poster_image": null
  },
  {
    "active": false,
     
    "title": "The Problem with Our Parks",
     
     
    "__v": 0,
     
    "date": "2017-01-01T08:00:00.000Z",
    "description": "Greatly inspired by Edward Abbey's classic environmentalist text <em>Desert Solitaire</em>, this project seeks to interrogate the ways in which industrial tourism impedes the experience of national parks.\n<br><br>\nIt does so by putting excerpts of Desert Solitaire in conversation with <em>The Crystal Goblet</em>, Beatrice Warde's seminal essay on the merits of typographic restraint. The book draws the two texts together with marginalia that highlight intersections and parallelisms. It also features original illustrations, created in a simple style and overlaid with refined National Park photography, to highlight how careless development impedes the experience of natural beauty.",
    "order": 9,
    "role": "Designer",
    "tags": "Book, Dialogue",
    "type": "design",
    "additional_images": [],
    "carousel_images": [
      {
         
         
         
        "__v": 0,
        "base_image": {
           
          "name": "parks1.jpg",
           
          "hash": "8b95f65d672143e2b8db8ca0207d5b6a",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "791.86",
          "url": "/uploads/8b95f65d672143e2b8db8ca0207d5b6a.jpg",
           
          "related": [
            "5d9f6ec22459af12b19ed64f"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
         
         
        "__v": 0,
        "base_image": {
           
          "name": "parks2.jpg",
           
          "hash": "6e8cf3ac5d624ac592c47f53c4f0d5aa",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "661.89",
          "url": "/uploads/6e8cf3ac5d624ac592c47f53c4f0d5aa.jpg",
           
          "related": [
            "5d9f6ec22459af12b19ed650"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
         
         
        "__v": 0,
        "base_image": {
           
          "name": "parks3.jpg",
           
          "hash": "7ce811cb0bb342e4a3f5572ee47c83cb",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "732.27",
          "url": "/uploads/7ce811cb0bb342e4a3f5572ee47c83cb.jpg",
           
          "related": [
            "5d9f6ec22459af12b19ed651"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
         
         
        "__v": 0,
        "base_image": {
           
          "name": "parks4.jpg",
           
          "hash": "d2646cd5b9dd4dc9bb7ab2d3b4bbf0d7",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "723.50",
          "url": "/uploads/d2646cd5b9dd4dc9bb7ab2d3b4bbf0d7.jpg",
           
          "related": [
            "5d9f6ec22459af12b19ed652"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
         
         
        "__v": 0,
        "base_image": {
           
          "name": "parks5.jpg",
          "sha256": "6W3Qjtq-BMm_9MqNXnFV4Gg3HzWTvYEqg9WLFM++SNk",
          "hash": "5868bbd37b7e4031b28b6a1fdbc52640",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "735.15",
          "url": "/uploads/5868bbd37b7e4031b28b6a1fdbc52640.jpg",
           
          "related": [
            "5d9f6ec22459af12b19ed653"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
         
         
        "__v": 0,
        "base_image": {
           
          "name": "parks6.jpg",
           
          "hash": "ae30a22a1a24450fbdecf9675567233c",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "748.28",
          "url": "/uploads/ae30a22a1a24450fbdecf9675567233c.jpg",
           
          "related": [
            "5d9f6ec22459af12b19ed654"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
         
         
        "__v": 0,
        "base_image": {
           
          "name": "parks7.jpg",
           
          "hash": "02935052d7a149f9bef184f3a210f433",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "640.58",
          "url": "/uploads/02935052d7a149f9bef184f3a210f433.jpg",
           
          "related": [
            "5d9f6ec22459af12b19ed655"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
         
         
        "__v": 0,
        "base_image": {
           
          "name": "parks8.jpg",
           
          "hash": "3654ee270de04693909f193636357c9a",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "968.87",
          "url": "/uploads/3654ee270de04693909f193636357c9a.jpg",
           
          "related": [
            "5d9f6ec22459af12b19ed656"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
         
         
        "__v": 0,
        "base_image": {
           
          "name": "parks9.jpg",
           
          "hash": "3e70114fcdff40d38e1164c134456b40",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "662.18",
          "url": "/uploads/3e70114fcdff40d38e1164c134456b40.jpg",
           
          "related": [
            "5d9f6ec22459af12b19ed657"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
         
         
        "__v": 0,
        "base_image": {
           
          "name": "parks10.jpg",
           
          "hash": "08be429818004b55a66fa2884d198bd3",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "769.62",
          "url": "/uploads/08be429818004b55a66fa2884d198bd3.jpg",
           
          "related": [
            "5d9f6ec22459af12b19ed658"
          ],
           
           
          "__v": 0,
           
        },
         
      }
    ],
    "cover_image": null,
    "kind": "Book",
    "short_description": "",
    "poster_image": null
  },
  {
    "active": false,
    "title": "Sallysaurus Game",
    "__v": 0,
    "date": "2018-05-01T08:00:00.000Z",
    "description": "A set of vector based illustrations as proposals for the image identity of a side-scroller iPhone game. Game settings were created with assests of characters, continous screens and interactive game objects. The screens were then cropped for view in the game window. The game, Sallysaurus, presents two dinosaur characters competing to protect or steal eggs while collecting items.",
    "order": 8,
    "role": "Designer, Illustrator",
    "tags": "Side-Scroller, Vector",
    "type": "illustration",
    "additional_images": [],
    "carousel_images": [
      {
         
         
         
        "__v": 0,
        "alt": "Illustration of the title screen for an iphone game called sallysaurus",
        "base_image": {
           
          "name": "sallyscreen1.jpg",
           
          "hash": "e1d6f00f551c41bbbde6a9be4f7e697d",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "208.25",
          "url": "/uploads/e1d6f00f551c41bbbde6a9be4f7e697d.jpg",
           
          "related": [
            "5d9f6f0e2459af12b19ed677"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
         
         
        "__v": 0,
        "alt": "Illustration of an iphone game where a dinosaur chases an egg",
        "base_image": {
           
          "name": "sallyscreen2.jpg",
           
          "hash": "199ae03222ee49d0950fdf21db2fcc30",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "570.78",
          "url": "/uploads/199ae03222ee49d0950fdf21db2fcc30.jpg",
           
          "related": [
            "5d9f6f0e2459af12b19ed678"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
         
         
        "__v": 0,
        "alt": "Illustration of an iphone game featuring two dinosaurs chasing eggs",
        "base_image": {
           
          "name": "sallyscreen3.jpg",
           
          "hash": "b5d372b196e94d9fa44e5c967187473d",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "282.24",
          "url": "/uploads/b5d372b196e94d9fa44e5c967187473d.jpg",
           
          "related": [
            "5d9f6f0e2459af12b19ed679"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
         
         
        "__v": 0,
        "alt": "Illustration of an iphone game where one dinosaur fights of two others",
        "base_image": {
           
          "name": "sallyscreen4.jpg",
           
          "hash": "d70c09e55b9d43fb80f4b21d56347d17",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "413.44",
          "url": "/uploads/d70c09e55b9d43fb80f4b21d56347d17.jpg",
           
          "related": [
            "5d9f6f0e2459af12b19ed67a"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
         
         
        "__v": 0,
        "alt": "Illustration of an iphone game featuring two dinosaurs",
        "base_image": {
           
          "name": "sallyscreen5.jpg",
           
          "hash": "c4a580165f984a93a62b12bfd1249ace",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "333.89",
          "url": "/uploads/c4a580165f984a93a62b12bfd1249ace.jpg",
           
          "related": [
            "5d9f6f0e2459af12b19ed67b"
          ],
           
           
          "__v": 0,
           
        },
         
      }
    ],
    "cover_image": {
       
      "alt": "Illustration of an iphone game featuring two dinosaurs",
       
       
      "__v": 0,
      "base_image": {
         
        "name": "sallyscreen5.jpg",
         
        "hash": "ee44ee8b252a47fea77a207add9d27db",
        "ext": ".jpg",
        "mime": "image/jpeg",
        "size": "333.89",
        "url": "/uploads/ee44ee8b252a47fea77a207add9d27db.jpg",
         
        "related": [
          "5da658f93b4c2d68bce5664a"
        ],
         
         
        "__v": 0,
         
      },
       
    },
    "kind": "Illustration",
    "short_description": "Character and environment illustrations for a side-scroller iPhone game about Dinosaurs.",
    "poster_image": null
  },
  {
    "active": false,
     
    "title": "Good Ground Food Pantry",
     
     
    "__v": 0,
     
    "date": "2018-01-01T08:00:00.000Z",
    "description": "Good Ground Pantry is an emergency food pantry located in St. Louis Missouri, providing groceries to approximately 3,000 clients a year. Good Ground needed a logo and brand identity to create promotional materials, and to establish a consistent and familiar image for its clients.\n<br><br>\nWith a team of 6 students working on the project, our first goal was defining a logo—we presented a range of typographic approaches to the client. After refining the approaches, we are currently creating promotional samples and color palletes to refine the final indentity.",
    "order": 11,
    "role": "Designer",
    "tags": "Identity",
    "team": "Washington University Students",
    "type": "design",
    "additional_images": [],
    "carousel_images": [],
    "cover_image": {
       
       
       
      "__v": 0,
      "alt": "Text logo with the words Good Ground and a growing leaf",
      "base_image": {
         
        "name": "goodground1.jpg",
         
        "hash": "22bf87bf65924d2ca7841d175a4d6bfd",
        "ext": ".jpg",
        "mime": "image/jpeg",
        "size": "413.75",
        "url": "/uploads/22bf87bf65924d2ca7841d175a4d6bfd.jpg",
         
        "related": [
          "5d9f6f9f2459af12b19ed6b5"
        ],
         
         
        "__v": 0,
         
      },
       
    },
    "kind": "Identity",
    "short_description": "Identity redesign for a St. Louis area food pantry.",
    "poster_image": null
  },
  {
    "active": false,
     
    "title": "Nursery Rhymes",
     
     
    "__v": 0,
     
    "date": "2017-01-01T08:00:00.000Z",
    "description": "A series of illustrations based on the classic Mother Goose Nursery Rhymes: Old King Cole, There Was An Old Woman Tossed Up in a Blanked, and Little Nancy Etticoat. The series was drawn with ink, then colored digitally with a limited pallete.",
    "order": 12,
    "role": "Illustrator",
    "tags": "Posters, Series",
    "type": "illustration",
    "additional_images": [],
    "carousel_images": [
      {
         
         
         
        "__v": 0,
        "alt": "A set of three posters, each showing a figure from a nursery rhyme",
        "title": "3 posters",
        "base_image": {
           
          "name": "nurseryRhymes1.jpg",
           
          "hash": "f4548d706b1e4499ab45676fb2f0913a",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "719.94",
          "url": "/uploads/f4548d706b1e4499ab45676fb2f0913a.jpg",
           
          "related": [
            "5d9f6f712459af12b19ed6a1"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
         
         
        "__v": 0,
        "alt": "An illustrated poster showing a seated king and the text \"old king cole\"",
        "title": "Old King Cole",
        "base_image": {
           
          "name": "nurseryRhymes2.jpg",
           
          "hash": "e85f27d69e3c4e9e8696e156e2fad8ca",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "458.01",
          "url": "/uploads/e85f27d69e3c4e9e8696e156e2fad8ca.jpg",
           
          "related": [
            "5d9f6f712459af12b19ed6a2"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
         
         
        "__v": 0,
        "alt": "An illustrated poster showing a woman in a teacup and the text little nancy etticoat",
        "title": "Nancy Etticoat",
        "base_image": {
           
          "name": "nurseryRhymes3.jpg",
           
          "hash": "f8182270c3a24821a35be41d5cb7d6f7",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "321.85",
          "url": "/uploads/f8182270c3a24821a35be41d5cb7d6f7.jpg",
           
          "related": [
            "5d9f6f712459af12b19ed6a3"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
         
         
        "__v": 0,
        "alt": "An illustrated poster showing a woman sweeping off the moon",
        "title": "Old woman",
        "base_image": {
           
          "name": "nurseryRhymes4.jpg",
           
          "hash": "57c00f797102490db7cb8e650d711b2e",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "490.23",
          "url": "/uploads/57c00f797102490db7cb8e650d711b2e.jpg",
           
          "related": [
            "5d9f6f712459af12b19ed6a4"
          ],
           
           
          "__v": 0,
           
        },
         
      }
    ],
    "cover_image": {
       
       
       
      "__v": 0,
      "base_image": {
         
        "name": "nurseryRhymes1.jpg",
         
        "hash": "8cbc9518b0cc4b5e99a4194b1bb7c0d0",
        "ext": ".jpg",
        "mime": "image/jpeg",
        "size": "719.94",
        "url": "/uploads/8cbc9518b0cc4b5e99a4194b1bb7c0d0.jpg",
         
        "related": [
          "5d9f6f712459af12b19ed6a9"
        ],
         
         
        "__v": 0,
         
      },
       
    },
    "kind": "Illustration",
    "short_description": "A series of illustrations based on three classic Mother Goose Nursery Rhymes.",
    "poster_image": null
  },
  {
    "active": false,
     
    "title": "Vote Poster",
     
     
    "__v": 0,
     
    "date": "2016-01-01T08:00:00.000Z",
    "description": "Inspired by AIGA's Get Out the Vote campaign to encourage voter participation, I created a political poster for the 2016 election season.\n<br><br>\nThe poster focuses specifically on campaign issues related to immigration; the poster targets Mexican-Americans—a demographic that often has relatively low voter turnout—by highlighting both the stakes that many Mexican-American and immigrant communities have in the election, but also the power that the individual voter has to influence the election results.",
    "order": 13,
    "role": "Illustrator",
    "tags": "Posters, Campaign",
    "additional_images": [],
    "carousel_images": [],
    "cover_image": {
       
       
       
      "__v": 0,
      "base_image": {
         
        "name": "vote-poster.jpg",
         
        "hash": "18dd52930bba4b139945bae44539b273",
        "ext": ".jpg",
        "mime": "image/jpeg",
        "size": "1542.87",
        "url": "/uploads/18dd52930bba4b139945bae44539b273.jpg",
         
        "related": [
          "5d9f6ffc2459af12b19ed6b9"
        ],
         
         
        "__v": 0,
         
      },
       
    },
    "kind": "Poster",
    "short_description": "Political poster for the 2016 election.",
    "poster_image": null
  },
  {
    "active": false,
     
    "title": "Cité International Des Arts",
    "order": 1,
    "description": "Upcoming residency at the Cité Internationale Des Arts in Paris, France, for November and December of 2019. I will be investigating the ways we digitize real world experiences and exploring alternative ways to make museums more accessible. ",
    "date": "2019-11-03T08:00:00.000Z",
    "role": "Resident Artist",
    "carousel_images": [],
    "cover_image": {
       
      "alt": "Logo for the Cité International Des Arts",
       
       
      "__v": 0,
      "base_image": {
         
        "name": "citelogo.png",
         
        "hash": "2b4f69068900480d9b23bdc7973ee2fe",
        "ext": ".png",
        "mime": "image/png",
        "size": "219.02",
        "url": "/uploads/2b4f69068900480d9b23bdc7973ee2fe.png",
         
        "related": [
          "5da13cdc245ffb9888eed35b"
        ],
         
         
        "__v": 0,
         
      },
       
    },
    "additional_images": [],
     
     
    "__v": 1,
    "kind": "Residency",
    "type": "design",
    "short_description": "Residency investigating the ways we digitize real world experiences and exploring alternative ways to make museums more accessible.",
    "poster_image": null,
     
  },
  {
    "active": false,
     
    "order": 15,
    "date": "2018-01-01T08:00:00.000Z",
    "kind": "Illustration",
    "role": "Illustrator",
    "title": "Cubicle Crafts",
    "tags": "Illustrations",
    "type": "illustration",
    "description": "A series of illlustrations drawn from the prompt of 'Cubicle Crafts'. Each illustration shows a different craft made from or for a part of the office. \"Six fun, quick crafting activities to redefine your workspace (and maybe even change your life!)\" Created digitally, inspired by George Wylesol.",
    "carousel_images": [
      {
         
        "alt": "Illustration of women's legs surrounded by plastic balls. ",
        "title": "Ball pit",
        "caption": "Craft 1: Cubicle Ball Pit",
         
         
        "__v": 0,
        "base_image": {
           
          "name": "ball-pit-01.jpg",
          "sha256": "fheO7w6YZgHi4zocdiSyiobSf6n_+uXOBL4JGm3sLzw",
          "hash": "b8957fa40a7d4f738b2e8a283d8ee574",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "3719.51",
          "url": "/uploads/b8957fa40a7d4f738b2e8a283d8ee574.jpg",
           
          "related": [
            "5da144b4eee28399f48a361d"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
        "alt": "Illustration of ",
        "caption": "Craft 2: Family Photo-shop",
        "title": "Family photoshop",
         
         
        "__v": 0,
        "base_image": {
           
          "name": "family-photoshop-01.jpg",
           
          "hash": "506d6b0b431e4fa892d8f7427e42ab97",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "6280.09",
          "url": "/uploads/506d6b0b431e4fa892d8f7427e42ab97.jpg",
           
          "related": [
            "5da144b4eee28399f48a361e"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
        "caption": "Craft 3: Skull pencil holder",
        "alt": "Illustration of a skull pencil holder",
        "title": "Skull pencil holder",
         
         
        "__v": 0,
        "base_image": {
           
          "name": "skull-real-01.jpg",
           
          "hash": "6bfc4eb61f0b4ce7ac1f86e080765ea3",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "9408.15",
          "url": "/uploads/6bfc4eb61f0b4ce7ac1f86e080765ea3.jpg",
           
          "related": [
            "5da144b4eee28399f48a361f"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
        "caption": "Craft 4: Office Garden ",
        "alt": "Illustration of a cubicle full of plants",
        "title": "Office garden",
         
         
        "__v": 0,
        "base_image": {
           
          "name": "urban-garden-01.jpg",
           
          "hash": "cc01b89cc908409c93fea5d460ab6a4e",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "8892.06",
          "url": "/uploads/cc01b89cc908409c93fea5d460ab6a4e.jpg",
           
          "related": [
            "5da144b4eee28399f48a3620"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
        "alt": "Illustration of cardboard focus blinders",
        "caption": "Craft 5: Cardboard Focus Blinders",
        "title": "Focus Blinders",
         
         
        "__v": 0,
        "base_image": {
           
          "name": "focus-blinders-01.jpg",
           
          "hash": "fae1dbb9ce224d0696e439d9e8a23426",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "11124.43",
          "url": "/uploads/fae1dbb9ce224d0696e439d9e8a23426.jpg",
           
          "related": [
            "5da144b4eee28399f48a3621"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
        "alt": "Illustration of a wizard in a cubicle hidden by a blanket",
        "caption": "Craft 6: Blanket Wizard's Cave",
        "title": "Wizards Cave",
         
         
        "__v": 0,
        "base_image": {
           
          "name": "wizards-cave-01.jpg",
           
          "hash": "6dab923c1bb14331a263146fdae93e67",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "7182.14",
          "url": "/uploads/6dab923c1bb14331a263146fdae93e67.jpg",
           
          "related": [
            "5da144b4eee28399f48a3622"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
        "alt": "Image of an office space full of cubicles and plants",
        "caption": "",
        "title": "Cubicle space",
         
         
        "__v": 0,
        "base_image": {
           
          "name": "cubicle-header-01.jpg",
           
          "hash": "54c5ef350b7148bda79882f2026f5306",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "21988.65",
          "url": "/uploads/54c5ef350b7148bda79882f2026f5306.jpg",
           
          "related": [
            "5da144b4eee28399f48a3623"
          ],
           
           
          "__v": 0,
           
        },
         
      }
    ],
    "cover_image": {
       
      "alt": "Drawing of a skull pencil holder",
      "title": "Skull pencil holder",
       
       
      "__v": 0,
      "base_image": {
         
        "name": "skull-real-01.jpg",
         
        "hash": "e4d15ef322f6470aaaf48d66c8cf8480",
        "ext": ".jpg",
        "mime": "image/jpeg",
        "size": "9408.15",
        "url": "/uploads/e4d15ef322f6470aaaf48d66c8cf8480.jpg",
         
        "related": [
          "5da144b5eee28399f48a362b"
        ],
         
         
        "__v": 0,
         
      },
       
    },
    "additional_images": [],
     
     
    "__v": 2,
    "short_description": "Illustrations for a set of fictional office crafting activities. ",
    "poster_image": null,
  },
  {
    "active": true,
    "order": 4,
    "date": "2019-08-14T08:00:00.000Z",
    "kind": "Website",
    "role": "Designer, Developer",
    "title": "Fox Fridays",
    "tags": "Workshops",
    "type": "development",
    "description": "A website for a program of workshops and skill-shares at Washington University in St. Louis.\n<br><br>\n The program sought to make resources more accessible, and inspire students, by connecting them with with tool workshops and with a directory of available tools and resources for students to access.",
    "carousel_images": [
      {
         
        "alt": "Icon form by two letter F's ",
        "title": "Logo",
         
         
        "__v": 0,
        "base_image": {
           
          "name": "foxfridays4.jpg",
           
          "hash": "9d7529ebfbc846379370db13b630b466",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "60.58",
          "url": "/uploads/9d7529ebfbc846379370db13b630b466.jpg",
           
          "related": [
            "5da14db2eee28399f48a365d"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
        "alt": "Website showing a list of tools and resources",
        "title": "Tools & Resources",
         
         
        "__v": 0,
        "base_image": {
           
          "name": "foxfridays2.jpg",
           
          "hash": "211f3f8b47a24a1cbce8d871a663b7b0",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "239.48",
          "url": "/uploads/211f3f8b47a24a1cbce8d871a663b7b0.jpg",
           
          "related": [
            "5da14db2eee28399f48a365e"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
        "alt": "Website showing the detail page of a workshop event",
        "title": "Workshop detail",
         
         
        "__v": 0,
        "base_image": {
           
          "name": "foxfridays1.jpg",
           
          "hash": "ddfe87c468c24c21868c1d5477e62d87",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "441.28",
          "url": "/uploads/ddfe87c468c24c21868c1d5477e62d87.jpg",
           
          "related": [
            "5da14db2eee28399f48a365f"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
        "alt": "Website showing a list of frequently asked questions and a case study",
        "title": "Faqs",
         
         
        "__v": 0,
        "base_image": {
           
          "name": "foxfridays3.jpg",
           
          "hash": "8ad4087d58914925a5aaba2d522c746c",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "size": "283.10",
          "url": "/uploads/8ad4087d58914925a5aaba2d522c746c.jpg",
           
          "related": [
            "5da14db2eee28399f48a3660"
          ],
           
           
          "__v": 0,
           
        },
         
      }
    ],
    "cover_image": null,
    "additional_images": [],
     
     
    "__v": 1,
    "short_description": "Website and identity for a weekly workshop program at Washington University in St. Louis.",
    "poster_image": null,
     
  },
  {
    "active": false,
     
    "title": "HCI Minor",
    "kind": "Microsite",
    "order": 21,
    "date": "2019-08-14T08:00:00.000Z",
    "role": "Designer, Developer",
    "description": "Microsite detailing a new Minor in Human Computer Interaction at Washington University in St. Louis. Designed to showcase the program, while also providing students with important information about program requirements. ",
    "tags": "Interactive, Microsite",
    "carousel_images": [
      {
         
        "title": "HCI Text",
        "alt": "Text showing the letters HCI",
         
         
        "__v": 0,
        "base_image": {
           
          "name": "Screen Shot 2019-10-11 at 9.26.19 PM.png",
           
          "hash": "62ac17077947467892a34b0caa2433a7",
          "ext": ".png",
          "mime": "image/png",
          "size": "173.94",
          "url": "/uploads/62ac17077947467892a34b0caa2433a7.png",
           
          "related": [
            "5da156812ac49da627493edf"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
        "alt": "Website showing text describing a minor program in Human Computer Interaction",
        "title": "Text detail",
         
         
        "__v": 0,
        "base_image": {
           
          "name": "Screen Shot 2019-10-11 at 9.18.04 PM.png",
           
          "hash": "36acf7ee5d774f378b558f66382c77f5",
          "ext": ".png",
          "mime": "image/png",
          "size": "317.93",
          "url": "/uploads/36acf7ee5d774f378b558f66382c77f5.png",
           
          "related": [
            "5da156812ac49da627493ee0"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
        "alt": "Website showing a series of numbers and the title Required Coursework",
        "title": "Coursework detail",
         
         
        "__v": 0,
        "base_image": {
           
          "name": "Screen Shot 2019-10-11 at 9.18.19 PM.png",
           
          "hash": "33d0e8c39320413d8ab25d5d4abc03be",
          "ext": ".png",
          "mime": "image/png",
          "size": "309.09",
          "url": "/uploads/33d0e8c39320413d8ab25d5d4abc03be.png",
           
          "related": [
            "5da156812ac49da627493ee1"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
        "alt": "Website showing a title Pillar Courses and detail text",
        "title": "Pillar courses",
         
         
        "__v": 0,
        "base_image": {
           
          "name": "Screen Shot 2019-10-11 at 9.19.22 PM.png",
           
          "hash": "22599596de024296917f168cab1cf8b6",
          "ext": ".png",
          "mime": "image/png",
          "size": "376.46",
          "url": "/uploads/22599596de024296917f168cab1cf8b6.png",
           
          "related": [
            "5da156812ac49da627493ee2"
          ],
           
           
          "__v": 0,
           
        },
         
      },
      {
         
        "alt": "Website showing a title Sample Tracks",
        "title": "Sample tracks",
         
         
        "__v": 0,
        "base_image": {
           
          "name": "Screen Shot 2019-10-11 at 9.20.18 PM.png",
           
          "hash": "99ca00099f5d4ff7be64c79d71eba1d3",
          "ext": ".png",
          "mime": "image/png",
          "size": "248.00",
          "url": "/uploads/99ca00099f5d4ff7be64c79d71eba1d3.png",
           
          "related": [
            "5da156812ac49da627493ee3"
          ],
           
           
          "__v": 0,
           
        },
         
      }
    ],
    "cover_image": {
       
      "alt": "Video example of a website's interactive elements",
       
       
      "__v": 0,
      "base_image": {
         
        "name": "f93626f67f7343eca052a50763c5fb5c.mp4",
         
        "hash": "40ece22385f34c50b21380953a6ec8e9",
        "ext": ".mp4",
        "mime": "video/mp4",
        "size": "556.99",
        "url": "/uploads/40ece22385f34c50b21380953a6ec8e9.mp4",
         
        "related": [
          "5daa32a97977e2ab62c0243d"
        ],
         
         
        "__v": 0,
         
      },
       
    },
    "additional_images": [],
     
     
    "__v": 0,
    "type": "development",
    "short_description": "Microsite for a new Minor program in HCI. ",
    "cover_video": [],
    "poster_image": {
       
      "alt": "The letters H, C and I, in large capitals in white on a black background",
       
       
      "__v": 0,
      "base_image": {
         
        "name": "Screen Shot 2019-10-19 at 10.28.09 AM.png",
         
        "hash": "744b755fe48347dbb4d8d9be9447e6bf",
        "ext": ".png",
        "mime": "image/png",
        "size": "236.11",
        "url": "/uploads/744b755fe48347dbb4d8d9be9447e6bf.png",
         
        "related": [
          "5dab47e2fb442ede413dd687"
        ],
         
         
        "__v": 0,
         
      },
       
    },
     
  }
]